import ApiService from "@/core/services/api.service";

// action types
export const GET_TOTALES = "getTotales";
export const GET_TOTALES_CAJEROS_ESTADO = "getTotalesCajerosEstados";
export const GET_TOTALES_CAJEROS_SUBESTADO = "getTotalesCajerosSubEstados";
export const GET_TOTALES_CAJEROS_MONEDA = "getTotalesCajerosMoneda";
export const GET_TOTALES_ATENDIDOS = "getTotalesAtendidos";
export const GET_TOTALES_NO_ATENDIDOS = "getTotalesNoAtendidos";

export const SET_ERROR = "setError";
export const SET_TOTALES_CAJEROS_ESTADO = "setTotalesCajerosEstados";
export const SET_TOTALES_CAJEROS_SUBESTADO = "setTotalesCajerosSubEstados";
export const SET_TOTALES_CAJEROS_MONEDA = "setTotalesCajerosMoneda";
export const SET_TOTALES_ATENDIDOS = "setTotalesAtendidos";
export const SET_TOTALES_NO_ATENDIDOS = "setTotalesNoAtendidos";

const state = {
  errors: null,
  estados: [],
  subEstados: [],
  monedas: [],
  atendidos: [],
  noAtendidos: [],
};

const actions = {
  [GET_TOTALES](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Estadistica/v1/Totales` }, "")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },

  [GET_TOTALES_CAJEROS_ESTADO](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get(
        { action: `/facturacioncomisionapi/api/Estadistica/v1/TotalesCajerosEstados` },
        ""
      )
        .then(({ data }) => {
          context.commit(SET_TOTALES_CAJEROS_ESTADO, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log(("err" + response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
  [GET_TOTALES_CAJEROS_SUBESTADO](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get(
        { action: `/facturacioncomisionapi/api/Estadistica/v1/TotalesCajerosSubEstados` },
        ""
      )
        .then(({ data }) => {
          context.commit(SET_TOTALES_CAJEROS_SUBESTADO, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log(("err" + response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
  [GET_TOTALES_CAJEROS_MONEDA](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Estadistica/v1/TotalesCajerosMoneda` }, "")
        .then(({ data }) => {
          context.commit(SET_TOTALES_CAJEROS_MONEDA, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log(("err" + response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
  [GET_TOTALES_ATENDIDOS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Estadistica/v1/TotalesAtendidos` }, "")
        .then(({ data }) => {
          context.commit(SET_TOTALES_ATENDIDOS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log(("err" + response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
  [GET_TOTALES_NO_ATENDIDOS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.get({ action: `/facturacioncomisionapi/api/Estadistica/v1/TotalesNoAtendidos` }, "")
        .then(({ data }) => {
          context.commit(SET_TOTALES_NO_ATENDIDOS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log(("err" + response);
          context.commit(SET_ERROR, ""); //response.data.errors);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_TOTALES_CAJEROS_ESTADO](state, estados) {
    state.errors = {};
    state.estados = estados;
  },
  [SET_TOTALES_CAJEROS_SUBESTADO](state, subEstados) {
    state.errors = {};
    state.subEstados = subEstados;
  },
  [SET_TOTALES_CAJEROS_MONEDA](state, monedas) {
    state.errors = {};
    state.monedas = monedas;
  },
  [SET_TOTALES_ATENDIDOS](state, atendidos) {
    state.errors = {};
    state.atendidos = atendidos;
  },
  [SET_TOTALES_NO_ATENDIDOS](state, noAtendidos) {
    state.errors = {};
    state.noAtendidos = noAtendidos;
  },
};

export default {
  state,
  actions,
  mutations,
};
